import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useState } from "react";
import TextInput from "../TextInput";

export const PasswordInput = ({
  id,
  buttonEnd,
  label,
  value,
  required,
  style,
  onChange,
  onKeyPress,
  type,
  icon,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <TextInput
        id={id}
        aria-label="showPasswordButton"
        type={showPassword ? "text" : type}
        value={value}
        onChange={onChange}
        buttonEnd={
          <IconButton size="small" onClick={handleClickShowPassword}>
            {showPassword ? <Visibility color="primary" /> : <VisibilityOff color="primary" />}
          </IconButton>
        }
        onKeyPress={onKeyPress}
        icon={icon}
        {...rest}
      />
    </>
  );
};
// biome-ignore lint/style/noDefaultExport: React Lazy
export default PasswordInput;
